<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { http } from '../../../../services/config/config-receituario'
import { VMoney } from 'v-money'
import clienteService from '@/src/services/produtor-rural'
import notaFiscalService from '@/src/services/api-receituario/nota-fiscal'
import formProdutoEstoque from '@/src/components/form-produto-estoque'

import moment from 'moment'
moment.locale('pt-br')
/**
 * Entrada de Nota Fiscal
 */
export default {
  components: {
    Layout,
    Loading,
    vueDropzone: vue2Dropzone,
    formProdutoEstoque,
  },
  directives: { money: VMoney },
  data() {
    return {
      mostraForm: true,
      isLoading: false,
      currentPage: 1,
      perPage: 20,
      produto: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      nfe: {},
      nfes: [],
      clientes: [],
      notaField: [
        {
          key: 'nf',
          label: 'NF',
          class: 'size-col-20',
        },
        {
          key: 'serie',
          label: 'Série',
          class: 'size-col-20',
        },
        {
          key: 'data_emissao',
          label: 'Data de Emissão',
          class: 'size-col-20',
        },
        {
          key: 'valor',
          label: 'Valor',
          class: 'size-col-20',
        },
        {
          key: 'tipo',
          label: 'Tipo',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      produtosField: [
        {
          key: 'nome',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'quantidade',
          label: 'Quantidade',
          class: 'size-col-20',
        },
        {
          key: 'unidade',
          label: 'Unidade',
          class: 'size-col-20',
        },
        {
          key: 'valor',
          label: 'Valor',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      dropzoneOptions: {
        url: `${http.defaults.baseURL}/nfes/imports?ignoreReceituario=true`,
        thumbnailWidth: 150,
        timeout: 100000,
        maxFilesize: 3,
        maxFiles: 1,
        headers: { Authorization: this.$store.state.auth.currentUser.token },
        acceptedFiles: '.xml',
        addRemoveLinks: true,
        dictRemoveFile: 'Remover arquivo',
      },
    }
  },
  computed: {},

  watch: {
    mostraForm() {
      if (this.mostraForm) {
        this.findAllNf()
      }
    },
  },
  mounted() {
    this.findAllNf()
    this.findAllClient()
  },
  methods: {
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    cadastra() {
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.findAllNf()
        this.findAllClient()
      }
    },
    openModalProduto(produto, index) {
      this.produto.id_produto = null
      this.produto.nome = produto.nome
      this.produto.data_cadastro = this.nfe.data_emissao
      this.produto.custo_medio = produto.valor
      this.produto.estoque_disponivel = produto.quantidade
      this.produto.id_tipo_produto = produto.id_tipo_produto
      this.produto.id_unidade = produto.id_unidade
      this.produto.ativo = true
      this.produto.index = index
      this.produto.is_nf = true
      this.$bvModal.show('modal-produto')
    },
    onEventSaveProduto(data) {
      this.nfe.produtos[data.produto.index].id_produto = data.produto.id_produto
      this.nfe.produtos[data.produto.index].is_register =
        data.produto.is_register
      this.produto = {};
      this.$bvModal.hide('modal-produto')
    },
    onComplete: function () {
      for (const produto of this.nfe.produtos) {
        if (produto.id_produto == undefined || produto.id_produto == 0) {
          this.$bvToast.toast(
            'Existem produtos sem cadastro, pro favor realize seu cadastro',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
          return
        }
      }
      this.finalizar()
    },
    findAllNf() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      notaFiscalService
        .listar(token, this.filter)
        .then((resposta) => {
          this.nfes = resposta.data.nfes
          this.isLoading = false
        })
        .catch((error) => {
          this.clientes = []
          this.isLoading = false
        })
    },
    findAllClient() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      clienteService
        .listar(token, this.filter)
        .then((resposta) => {
          this.clientes = resposta.data.data
          this.isLoading = false
        })
        .catch((error) => {
          this.clientes = []
          this.isLoading = false
        })
    },
    finalizar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      this.nfe.id_cliente = this.nfe.id_produtor_rural
      this.nfe.tipo = 'E'
      notaFiscalService
        .salvar(token, this.nfe)
        .then((resposta) => {
          this.cadastra()
          this.$bvToast.toast('Nota fiscal incluída!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.isLoading = false
        })
        .catch((error) => {
          this.$bvToast.toast('Erro ao incluir Nota fiscal!', {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.isLoading = false
        })
    },
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    vsuccess(file, response) {
      const data = response.nfe
      this.nfe = data

      this.isLoading = false
      this.$bvToast.toast('Importado com sucesso!', {
        variant: 'success',
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
      this.$forceUpdate()
    },
    vsending(file, xhr, formData) {
      this.isLoading = true
    },
    verror(file) {
      this.isLoading = false
      this.$bvToast.toast(
        'Não foi possível importar o arquivo, por favor verifique se este arquivo já não foi importado!',
        {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        }
      )
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-10">
            <div class="titulo">Lançamento de Nota Fiscal</div>
            <div class="subTitulo"
              >Faça os lançamentos de Nota Fiscal aqui.</div
            >
          </div>
          <div class="col-md-2">
            <div class="float-right">
              <button class="btn btn-primary" @click="cadastra">
                <span v-if="mostraForm">Novo lançamento</span>
                <span v-else>Visualizar NF</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div v-if="mostraForm">
        <b-table
          striped
          hover
          responsive="sm"
          borderless
          bordered
          outlined
          small
          :items="nfes"
          :fields="notaField"
          :per-page="perPage"
          :filter="filter"
          show-empty
        >
          <template #empty="scope">
            <div class="row">
              <div class="col-md-12">
                <span>Nenhum lançamento de nota fiscal encontrado!</span>
              </div>
            </div>
          </template>
          <template v-slot:cell(data_emissao)="row">
            {{
              formatDate(row.item.data_emissao) !== 'Invalid date'
                ? formatDate(row.item.data_emissao)
                : row.item.data_emissao
            }}
          </template>
          <template v-slot:cell(tipo)="row">
            <span
              v-if="row.item.tipo === 'E'"
              variant="primary"
              class="pl-2 pr-2 pt-1 pb-1"
              >ENTRADA</span
            >
            <span
              v-else-if="row.item.tipo === 'S'"
              variant="info"
              class="pl-2 pr-2 pt-1 pb-1"
              >SAÍDA</span
            >
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          size="md"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>

      <div class="row" v-else>
        <div class="col-md-12">
          <form-wizard
            color="#008E75"
            next-button-text="Avançar"
            back-button-text="Voltar"
            finish-button-text="Concluir"
            @on-complete="onComplete"
          >
            <tab-content title="Arquivo XML">
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <vue-dropzone
                        id="dropzone"
                        ref="myVueDropzone"
                        :options="dropzoneOptions"
                        :use-custom-slot="true"
                        @vdropzone-success="vsuccess"
                        @vdropzone-sending="vsending"
                        @vdropzone-error="verror"
                      >
                        <div class="text-center">
                          <i class="h1 text-muted uil-cloud-upload"></i>
                          <h3>Selecione o arquivo XML para importação.</h3>
                          <span class="text-muted font-size-13">
                            (O arquivo deve ter no máximo 3MB e seguir o padrão
                            WebReceita.)
                          </span>
                        </div>
                      </vue-dropzone>
                    </div>
                  </div>
                </div>
              </div>
            </tab-content>
            <tab-content title="Informações da Nota">
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Cliente">
                    <v-select
                      class="style-select"
                      label="nome"
                      :options="clientes"
                      :reduce="(item) => item.id_produtor_rural"
                      :dense="true"
                      v-model="nfe.id_produtor_rural"
                    ></v-select>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="NF">
                    <b-form-input v-model="nfe.nf" />
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Série">
                    <b-form-input v-model="nfe.serie" />
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Data de Emissão">
                    <b-form-datepicker
                      id="datepicker-recebimento"
                      v-model="nfe.data_emissao"
                      placeholder=""
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      locale="pt-br"
                    >
                      <template v-slot:button-content>
                        <b-icon icon="calendar" variant="primary"></b-icon>
                      </template>
                    </b-form-datepicker>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Valor">
                    <b-form-input v-money="money" v-model.lazy="nfe.valor" />
                  </b-form-group>
                </div>
              </div>
            </tab-content>
            <tab-content title="Informações dos Produtos">
              <div class="row">
                <div class="col-md-12">
                  <b-table
                    striped
                    hover
                    responsive="sm"
                    borderless
                    bordered
                    outlined
                    small
                    :items="this.nfe.produtos"
                    :fields="produtosField"
                  >
                    <template v-slot:cell(quantidade)="row">
                      <span v-if="row.item.fator_conversao > 0">{{
                        row.item.quantidade * row.item.fator_conversao
                      }}</span>
                      <span v-else>{{ row.item.quantidade }}</span>
                    </template>
                  </b-table>
                </div>
              </div>
            </tab-content>
            <tab-content title="Finalizar">
              <div class="row">
                <div class="col-md-12">
                  <div class="titulo">Dados da nota</div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label
                    >Número da Nota Fiscal: <b>{{ nfe.nf }}</b></label
                  >
                </div>
                <div class="col-md-12">
                  <label
                    >Série: <b>{{ nfe.serie }}</b></label
                  >
                </div>
                <div class="col-md-12">
                  <label
                    >Data de Emissão:
                    <b>
                      {{
                        formatDate(nfe.data_emissao) !== 'Invalid date'
                          ? formatDate(nfe.data_emissao)
                          : nfe.data_emissao
                      }}
                    </b></label
                  >
                </div>
                <div class="col-md-12">
                  <label
                    >Valor: <b>{{ nfe.valor }}</b></label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="borda"></div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="titulo">Dados do produto</div>
                </div>
                <div class="col-md-12" v-for="(produto, index) in nfe.produtos">
                  <label
                    >Produto: <b>{{ produto.nome }} </b>
                  </label>
                  -
                  <label v-show="produto.is_register">
                    <a
                      class="link-new-register"
                      href="#"
                      @click="openModalProduto(produto, index)"
                      >(Produto não localizado! Clique aqui para cadastrar)</a
                    ></label
                  >
                  <br />
                  <label
                    >Unidade: <b>{{ produto.unidade }}</b></label
                  ><br />
                  <label v-if="produto.fator_conversao > 0"
                    >Quantidade:
                    <b>{{
                      produto.quantidade * produto.fator_conversao
                    }}</b></label
                  >
                  <label v-else
                    >Quantidade: <b>{{ produto.quantidade }}</b></label
                  ><br />

                  <label
                    >Valor: <b>{{ produto.valor }}</b></label
                  ><br />

                  <div class="borda"></div>
                </div>
              </div>
            </tab-content>
          </form-wizard>
        </div>
      </div>

      <div v-if="mostraForm"> </div>
    </div>

    <b-modal
      id="modal-produto"
      title="Cadastro de Produto"
      title-class="font-18"
      size="xl"
    >
      <div class="row">
        <div class="col-md-12">
          <formProdutoEstoque :produto="produto" @onSave="onEventSaveProduto" />
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="$bvModal.hide('modal-produto')"
          >Fechar</b-button
        >
      </template>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.link-new-register {
  color: red;
}
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>